export default __webpack_public_path__ + "static/media/about.1e76690a.svg";